module.exports = __webpack_public_path__ + "static/media/Results-9.5f331e8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-9.jpg
// module id = 372
// module chunks = 0